import {Configuration} from "../configuration.model";

export const configuration: Configuration = {
	dekraMotherPage: "https://www.dekra.us/en/system-certification/overview/",
	dateTimeFormat: 'MM.dd.y, h:mm a',
	dateFormat: 'MM.dd.y',
	timeFormat: 'h:mm a',

	footer: {
		items: [
			{
				label: "PHONE 215-997-4519",
				link: "tel: 215-997-4519"
			},
			{
				label: "E-MAIL SALES.US@DEKRA.COM",
				link: "mailto: sales.us@dekra.com"
			},
			{
				label: "IT-SUPPORT",
				link: "mailto: support.audit-shop@dekra.com"
			},
			{
				label: "PRIVACY POLICY",
				link: "https://www.dekra.us/en/privacy-policy/",
			},
			{
				label: "TERMS OF USE",
				link: "https://www.dekra.us/en/terms-of-use/"
			},
			{
				label: "COOKIE POLICY",
				link: "https://www.dekra.us/en/cookie-policy/"
			},
			{
				label: "COOKIE SETTINGS",
				link: "order/cookies-settings",
				isRelativeUrl: true
			},
			{
				label: "CALIFORNIA PRIVACY NOTICE",
				link: "https://www.dekra.us/en/california-privacy-notice/"
			},
			{
				label: "DO NOT SELL MY PERSONAL INFORMATION",
				link: "https://www.dekra.us/en/ccpa-do-not-sell/"
			},
			{
				label: "TRADEMARKS",
				link: "https://www.dekra.us/en/trademarks/"
			}
		]
	},

	cookieBanner: {
		items: [
			{
				id: "privacy-policy",
				label: "Privacy policy",
				link: "https://www.dekra.us/en/privacy-policy/"
			},
			{
				id: "cookies-settings",
				label: "settings",
				link: "order/cookies-settings",
				isRelativeUrl: true
			},
			{
				id: "legal-notices",
				label: "Legal Notices",
				link: "https://www.dekra.us/en/terms-of-use/",
				isRelativeUrl: false,
				openInSameTab: false
			}
		]
	},

	cookieSettings: {
		comfort: [],
		mandatory: [],
		marketing: [],
		statistics: [{
			id: 'statistics.google',
			name: 'Google Tag Manager + Google Analytics',
			details: [
				{key: 'provider', value: 'Google Ireland Sp. z o.o.'},
				{key: 'description', value: 'Cookie for website analysis. Generates statistical data about how the visitor uses the website.'},
				{key: 'privacyStatement', value: 'https://policies.google.com/privacy', isUrl: true},
				{key: 'domain', value: 'Google'},
				{key: 'name', value: ['_ga', '_gat', '_gid']},
				{key: 'duration', value: '2 years'}
			]
		}]
	},

	setCookiesOnStartup: true


}
